import styled from 'styled-components';

export const Button = styled.button`
  padding: 0.8rem 1.5rem;
  background-color: ${({ theme, $variant }) => 
    $variant === 'secondary' ? theme.colors.secondary : 
    $variant === 'danger' ? theme.colors.danger : 
    theme.colors.tertiary};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
